import React, { useState } from 'react';

interface ApiKeyModalProps {
    onSubmit: (key: string) => void;
}

const ApiKeyModal: React.FC<ApiKeyModalProps> = ({ onSubmit }) => {
    const [key, setKey] = useState('');

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (key.trim()) {
            onSubmit(key.trim());
        }
    };

    return (
        <div className="fixed inset-0 bg-slate-900/80 backdrop-blur-sm z-50 flex items-center justify-center p-4">
            <div className="bg-white dark:bg-slate-800 rounded-lg shadow-xl w-full max-w-md p-8">
                <h2 className="text-2xl font-bold text-center text-slate-900 dark:text-white mb-4">Admin Access Required</h2>
                <p className="text-center text-slate-600 dark:text-slate-300 mb-6">
                    Please enter your Admin API Key to manage site configurations. This key is defined in the backend's `.env` file.
                </p>
                <form onSubmit={handleSubmit}>
                    <label htmlFor="api-key" className="sr-only">Admin API Key</label>
                    <input
                        id="api-key"
                        type="password"
                        value={key}
                        onChange={(e) => setKey(e.target.value)}
                        placeholder="Enter your secret key"
                        className="w-full bg-slate-100 dark:bg-slate-700 border border-slate-300 dark:border-slate-600 rounded-md p-3 text-slate-900 dark:text-white placeholder-slate-400 dark:placeholder-slate-500 focus:ring-2 focus:ring-cyan-500 focus:outline-none"
                        required
                    />
                    <button type="submit" className="mt-6 w-full py-3 px-4 bg-cyan-600 text-white font-semibold rounded-full hover:bg-cyan-500 transition">
                        Authenticate
                    </button>
                </form>
            </div>
        </div>
    );
};

export default ApiKeyModal;
